export interface AdHocOrderIdentifiers {
  orderNumber: string;
  ewsOrderNumber: string;
}

const MAX_EWS_ORDER_NUMBER_LENGTH = 30;

const pad = (value: number): string => value.toString().padStart(2, '0');

const toUtcTimestamp = (date: Date): string => {
  return `${date.getUTCFullYear()}${pad(date.getUTCMonth() + 1)}${pad(date.getUTCDate())}${pad(date.getUTCHours())}${pad(date.getUTCMinutes())}${pad(date.getUTCSeconds())}`;
};

export const generateAdHocOrderIdentifiers = (storeNumber: string, now: Date = new Date()): AdHocOrderIdentifiers => {
  const safeStore = (storeNumber || 'UNKNOWN').replace(/\s+/g, '').toUpperCase();
  const base = `ADHOC${toUtcTimestamp(now)}${safeStore}`;
  const limitedBase = base.slice(0, MAX_EWS_ORDER_NUMBER_LENGTH);

  return {
    orderNumber: limitedBase,
    ewsOrderNumber: limitedBase,
  };
};

export const generateAdHocEwsOrderNumber = (
  storeNumber: string,
  supplierName: string,
  now: Date = new Date(),
): string => {
  const safeStore = (storeNumber || 'UNKNOWN').replace(/\s+/g, '').toUpperCase();
  const safeSupplier = (supplierName || '')
    .replace(/[^A-Za-z0-9]/g, '')
    .toUpperCase();
  const base = `ADHOC${toUtcTimestamp(now)}${safeStore}`;

  if (!safeSupplier) {
    return base.slice(0, MAX_EWS_ORDER_NUMBER_LENGTH);
  }

  return `${base}${safeSupplier}`.slice(0, MAX_EWS_ORDER_NUMBER_LENGTH);
};
